import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter } from "lucide-react";
import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("Suscrito. Recibirás tu guía de fragancias por email.");
      setEmail("");
    } catch (err) {
      toast.error("Email inválido");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-navy text-cream/80 pt-20 pb-8" data-testid="footer">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        {/* Newsletter */}
        <div className="grid md:grid-cols-2 gap-12 pb-16 border-b border-cream/10">
          <div>
            <h3 className="text-3xl md:text-5xl font-serif text-cream leading-tight">
              La guía de fragancias.<br /><span className="text-royal italic">En tu email.</span>
            </h3>
            <p className="mt-6 max-w-md text-cream/60 leading-relaxed">
              Suscríbete y recibe una muestra en tu próximo pedido, además de nuestra guía de familias olfativas.
            </p>
          </div>
          <form onSubmit={subscribe} className="flex flex-col justify-end gap-4" data-testid="newsletter-form">
            <div className="flex border-b border-cream/30 focus-within:border-cream">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tu@email.com"
                data-testid="newsletter-email"
                className="flex-1 bg-transparent py-3 outline-none text-cream placeholder:text-cream/40"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="newsletter-submit"
                className="font-mono-caps px-4 hover:text-cream transition-colors"
              >
                {loading ? "…" : "Suscribir"}
              </button>
            </div>
            <p className="text-xs text-cream/40">Sin spam. Cancela cuando quieras.</p>
          </form>
        </div>

        {/* Columns */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10 py-16 border-b border-cream/10">
          <div className="col-span-2">
            <div className="flex items-center gap-3">
              <img src="/brand/logo.png" alt="Pure Fragance" className="h-14 w-14 object-cover rounded-full" />
              <div className="text-cream tracking-[0.3em] text-lg font-serif">PURE FRAGANCE</div>
            </div>
            <p className="mt-4 text-cream/60 text-sm leading-relaxed max-w-xs">
              Perfumes 100% originales, con envío rápido y atención experta.
            </p>
            <div className="flex gap-3 mt-6">
              <a href="#" className="p-2 border border-cream/20 hover:border-cream hover:text-cream transition-colors" aria-label="Instagram"><Instagram strokeWidth={1.25} className="h-4 w-4" /></a>
              <a href="#" className="p-2 border border-cream/20 hover:border-cream hover:text-cream transition-colors" aria-label="Facebook"><Facebook strokeWidth={1.25} className="h-4 w-4" /></a>
              <a href="#" className="p-2 border border-cream/20 hover:border-cream hover:text-cream transition-colors" aria-label="Twitter"><Twitter strokeWidth={1.25} className="h-4 w-4" /></a>
            </div>
          </div>

          <div>
            <div className="font-mono-caps mb-4 text-cream">Tienda</div>
            <ul className="space-y-2 text-sm text-cream/60">
              <li><Link to="/shop" className="hover:text-cream">Novedades</Link></li>
              <li><Link to="/shop?sort=bestsellers" className="hover:text-cream">Más vendidos</Link></li>
              <li><Link to="/shop?badge=Edición%20limitada" className="hover:text-cream">Ediciones exclusivas</Link></li>
              <li><Link to="/shop" className="hover:text-cream">Todos los perfumes</Link></li>
            </ul>
          </div>

          <div>
            <div className="font-mono-caps mb-4 text-cream">Ayuda</div>
            <ul className="space-y-2 text-sm text-cream/60">
              <li><Link to="/autenticidad" className="hover:text-cream">Originalidad 100%</Link></li>
              <li><Link to="/envios" className="hover:text-cream">Envíos y entregas</Link></li>
              <li><Link to="/devoluciones" className="hover:text-cream">Devoluciones 30 días</Link></li>
              <li><Link to="/contacto" className="hover:text-cream">Contacto</Link></li>
            </ul>
          </div>

          <div>
            <div className="font-mono-caps mb-4 text-cream">Legal</div>
            <ul className="space-y-2 text-sm text-cream/60">
              <li><Link to="/privacidad" className="hover:text-cream">Privacidad</Link></li>
              <li><Link to="/cookies" className="hover:text-cream">Cookies</Link></li>
              <li><Link to="/terminos" className="hover:text-cream">Términos</Link></li>
              <li><Link to="/accesibilidad" className="hover:text-cream">Accesibilidad</Link></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row justify-between gap-4 text-xs text-cream/40">
          <div>© {new Date().getFullYear()} PURE FRAGANCE · Todos los derechos reservados</div>
          <div className="font-mono-caps">Pagos seguros · Stripe · Apple Pay · Google Pay</div>
        </div>
      </div>
    </footer>
  );
}
